import React from 'react';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import Paper from '@material-ui/core/Paper';
import LinearProgress from '@material-ui/core/LinearProgress';
import InputAdornment from '@material-ui/core/InputAdornment';
import Tooltip from '@material-ui/core/Tooltip';
import TextField from '@material-ui/core/TextField';
import Chip from '@material-ui/core/Chip';
import Button from '@material-ui/core/Button';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import IconButton from '@material-ui/core/IconButton';
import AddIcon from '@material-ui/icons/AddCircle';
import Avatar from '@material-ui/core/Avatar';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Menu from '@material-ui/core/Menu';
import MenuList from '@material-ui/core/MenuList';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import FileUpload from './file-upload';
import { getListEscolaridade, getItemList, formataCentavoZerado } from '../modules/util';


export default class GrupoFamiliar extends React.Component {

    state = {
        indice: -1,
        item: {},
        erro: "",
        famNome: "",
        famIdade: "",
        famParentesco: "",
        famEscolaridade: "",
        famProfissao: "",
        famRendaBruta: "",
        anchorEl: null,
        isEdicao: false
    };

    componentDidMount() {
        this.props.addCadastroNoGrupoFamiliar();
        document.querySelector(".scrollView").scrollIntoView({ behaviour: "smooth" });
    }

    handleClick = (item, indice, event) => {
        this.setState({ anchorEl: event.currentTarget, item: item, indice: indice });
    };

    handleClose = () => {
        this.setState({ anchorEl: null, indice: -1 });
    };

    onEditar = () => {
        this.setState({
            anchorEl: null,
            isEdicao: true,
            famCpf: this.state.pesCpf,
            famNome: this.state.item.famNome,
            famIdade: this.state.item.famIdade,
            famParentesco: this.state.item.famParentesco,
            famEscolaridade: this.state.item.famEscolaridade,
            famProfissao: this.state.item.famProfissao,
            famRendaBruta: this.state.item.famRendaBruta
        }, () => {
            setTimeout(() => {
                document.querySelector(".scrollIntoViewParente").scrollIntoView({ behaviour: "smooth" });
            }, 150);
        });
    };

    onCancelar = () => {
        this.setState({
            indice: -1,
            isEdicao: false,
            erro: "",
            famNome: "",
            famIdade: "",
            famCpf: "",
            famParentesco: "",
            famEscolaridade: "",
            famProfissao: "",
            famRendaBruta: ""
        });
    };

    onDelete = () => {
        this.props.deletePessoaGrupoFamiliar(this.state.indice);
        this.handleClose();


    };
    onChange(id, valor) {

        if (id === "famRendaBruta") {
            valor = valor.replace(/\./gim, "");
            valor = formataCentavoZerado(valor);
        }
        this.setState({
            [id]: valor
        });
    }

    addIntegrante = () => {
        if (!this.state.famNome ||
            !this.state.famIdade ||
            !this.state.famParentesco ||
            !this.state.famEscolaridade ||
            !this.state.famProfissao ||
            this.state.famRendaBruta === "") {
            var erro = "Informe todos os campos do familiar";
            this.props.addErro(erro);
            this.setState({ erro })
            return;
        }
        if(Number(this.state.famIdade) >= 18 && !this.state.famCpf ){
            var erro = "Informe CPF";
            this.props.addErro(erro);
            this.setState({ erro })
            return;
        }

        var item = {
            famCpf: this.state.famCpf,
            famNome: this.state.famNome,
            famIdade: this.state.famIdade,
            famParentesco: this.state.famParentesco,
            famEscolaridade: this.state.famEscolaridade,
            famProfissao: this.state.famProfissao,
            famRendaBruta: this.state.famRendaBruta
        };
        if (this.state.isEdicao) {
            this.props.updatePessoaGrupoFamiliar(this.state.indice, item);
        } else {
            this.props.addPessoaGrupoFamiliar(item);
        }
        this.onCancelar();

    };

    render() {

        return (
            <div>
                <fieldset>
                    <legend>Grupo familiar</legend>
                    <br /> <br />
                    <FormControl className='item-form' >
                        <InputLabel autoFocus={this.state.indice >= 0} htmlFor="solTpMoradia">Condições de Moradia (Residência)</InputLabel>
                        <Select

                            style={{ width: "300px" }}
                            value={this.props.solTpMoradia}
                            onChange={(e) => this.props.changeCampoGenericoFamiliar("solTpMoradia", e.target.value)}
                            inputProps={{
                                id: 'solTpMoradia'
                            }}
                        >
                            <MenuItem value={0}>--SELECIONE--</MenuItem>
                            {this.props.listTpMoradia.map((item, indice) => {
                                return (
                                    <MenuItem key={indice} value={item.tip_seq}>{item.tip_descricao}</MenuItem>
                                );
                            })}
                        </Select>
                    </FormControl>

                    <div style={{ fontSize: "12px", margin: "70px 0" }}>
                        <p>
                            Preencha os campos a seguir com o nome das pessoas de seu grupo
                            familiar (todas as pessoas que residem na casa, inclusive você); <br />
                            *Entende-se como grupo familiar o conjunto de pessoas residindo na mesma moradia
                            do chefe do grupo familiar, que sejam relacionadas ao candidato pelos seguintes graus de parentesco:
                            </p>
                        {this.props.listParentesco.map((item, indice) => {
                            return (
                                <Chip key={indice} style={{ marginRight: "2px" }} label={item.text} />
                            );
                        })}
                    </div>

                    <div>
                        <div>
                            <FormControl
                                error={!!this.state.erro && !this.state.famParentesco}
                                className='item-form scrollIntoViewParente' style={{ width: "80px" }}>
                                <InputLabel   >Parentesco</InputLabel>
                                <Select


                                    style={{ width: "200px" }}
                                    value={this.state.famParentesco}
                                    onChange={(e) => this.onChange('famParentesco', e.target.value)}
                                >
                                    {this.props.listParentesco.map((item) => {
                                        return (
                                            <MenuItem key={item.value} value={item.value}>{item.text}</MenuItem>
                                        );
                                    })}
                                </Select>
                            </FormControl>
                        </div>
                        <FormControl

                            className='item-form' style={{ width: "40%", minWidth: "320px" }} >
                            <TextField
                                error={!!this.state.erro && !this.state.famNome}
                                type="text"
                                fullWidth
                                label="Nome"
                                value={this.state.famNome}
                                onChange={(e) => this.onChange('famNome', e.target.value)}
                                margin="normal"
                            />
                        </FormControl>
                        <FormControl

                            className='item-form' style={{ width: "20%", minWidth: "220px" }} >
                            <TextField
                               // error={!!this.state.erro && !this.state.famCpf}
                                type="number"
                                fullWidth
                                label="CPF"
                                value={this.state.famCpf}
                                onChange={(e) => this.onChange('famCpf', e.target.value)}
                                margin="normal"
                            />
                        </FormControl>
                        <FormControl
                            className='item-form' style={{ width: "80px" }}>
                            <TextField
                                error={!!this.state.erro && !this.state.famIdade}
                                type="number"
                                fullWidth
                                label="Idade"
                                value={this.state.famIdade}
                                onChange={(e) => this.onChange('famIdade', e.target.value)}
                                margin="normal"
                            />
                        </FormControl>


                        <FormControl
                            error={!!this.state.erro && !this.state.famEscolaridade}
                            className='item-form' style={{}} >

                            <InputLabel >Escolaridade</InputLabel>
                            <Select
                                style={{ width: "200px" }}
                                value={this.state.famEscolaridade}
                                onChange={(e) => this.onChange('famEscolaridade', e.target.value)}
                            >
                                {getListEscolaridade().map((item) => {
                                    return (
                                        <MenuItem key={item.value} value={item.value}>{item.text}</MenuItem>
                                    );
                                })}
                            </Select>
                        </FormControl>

                        <FormControl

                            className='item-form' style={{ width: "40%", minWidth: "220px" }}  >
                            <TextField
                                error={!!this.state.erro && !this.state.famProfissao}
                                type="text"
                                fullWidth
                                label="Cargo/Profissão"
                                value={(this.state.famProfissao)}
                                onChange={(e) => this.onChange('famProfissao', e.target.value)}
                                margin="normal"
                            />
                        </FormControl>
                        <FormControl
                            error={!!this.state.erro && !this.state.famRendaBruta}
                            className='item-form' style={{ minWidth: "120px" }}  >
                            <InputLabel htmlFor="pesRendaBruta">Renda   bruta mensal</InputLabel>
                            <Input
                                type="text"
                                fullWidth

                                placeholder="00,00"
                                value={(this.state.famRendaBruta && this.state.famRendaBruta.toString().replace(/\./gim, ","))}
                                onChange={(e) => this.onChange('famRendaBruta', (e.target.value))}
                                startAdornment={<InputAdornment position="start">R$</InputAdornment>}
                            />
                        </FormControl>
                        {this.state.isEdicao ? (
                            <Button
                                style={{ marginRight: "10px" }}
                                onClick={this.onCancelar}
                                variant="raised" color="primary"   >
                                Cancelar
                            </Button>
                        ) : null}

                        <Button
                            onClick={this.addIntegrante}
                            variant="raised" color="primary"   >
                            {this.state.isEdicao ? "Alterar" : (<React.Fragment> <AddIcon style={{ marginRight: "10px" }} />Adicionar Integrante </React.Fragment>)}
                        </Button>

                        <div style={{
                            display: (this.state.erro ? "block" : "none"),
                            margin: "20px",
                            padding: "20px",
                            textAlign: "center",
                            backgroundColor: "rgb(255, 209, 209)",
                            color: "red"
                        }}>
                            {this.state.erro}

                        </div>
                    </div>

                    <Paper style={{ marginTop: "80px" }} >
                        <Table style={{ width: "100%" }}>
                            <TableHead>
                                <TableRow>
                                    <TableCell component="th" scope="row">Nome&nbsp;</TableCell>
                                    <TableCell component="th" scope="row">CPF&nbsp;</TableCell>
                                    <TableCell numeric style={{ "padding": 0 }}>Idade</TableCell>
                                    <TableCell numeric style={{ "padding": "0 10px" }}> Parentesco </TableCell>
                                    <TableCell numeric>Escolaridade</TableCell>
                                    <TableCell numeric >Profissão</TableCell>
                                    <TableCell numeric>Renda Bruta</TableCell>
                                    <TableCell numeric > </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {this.props.listFamiliar.map((item, indice) => {
                                    var escolaridade = getItemList(getListEscolaridade(), item.famEscolaridade);
                                    var parentesco = getItemList(this.props.listParentesco, item.famParentesco);
                                    if (parentesco) {
                                        parentesco = parentesco.text;
                                    }
                                    var anchor = null;

                                    return (
                                        <TableRow key={indice}>
                                            <TableCell style={{ width: "300px" }}>
                                                {item.famNome}
                                            </TableCell>
                                            <TableCell numeric style={{ "padding": 0 }}>{item.famCpf}</TableCell>
                                            <TableCell numeric style={{ "padding": 0 }}>{item.famIdade}</TableCell>
                                            <TableCell numeric style={{ "padding": "0 10px" }}>{parentesco || "--"}</TableCell>
                                            <TableCell numeric>{escolaridade && escolaridade.text || '--'}</TableCell>
                                            <TableCell numeric>{item.famProfissao}</TableCell>
                                            <TableCell numeric>{item.famRendaBruta && item.famRendaBruta.toString().replace(/\./gim, ",")}</TableCell>
                                            <TableCell  >
                                                <IconButton
                                                    aria-label="More"
                                                    aria-haspopup="true"
                                                    onClick={this.handleClick.bind(this, item, indice)}
                                                >
                                                    <MoreVertIcon />
                                                </IconButton>

                                            </TableCell>
                                        </TableRow>
                                    );
                                })}
                            </TableBody>
                        </Table>
                        <Menu
                            transitionDuration={0}
                            anchorEl={this.state.anchorEl}
                            open={Boolean(this.state.anchorEl)}
                            onClose={this.handleClose}
                        >
                            <MenuItem disabled={this.state.isEdicao || this.state.item.isCadastro} onClick={this.onEditar} >
                                <ListItemIcon  >
                                    <EditIcon />
                                </ListItemIcon>
                                <ListItemText inset primary="Editar" />
                            </MenuItem>
                            <MenuItem disabled={this.state.isEdicao || this.state.item.isCadastro} onClick={this.onDelete}>
                                <ListItemIcon  >
                                    <DeleteIcon />
                                </ListItemIcon>
                                <ListItemText inset primary="Remover" />
                            </MenuItem>
                        </Menu>
                    </Paper>


                </fieldset>


                <FileUpload
                    origem="G"
                    listArquivos={this.props.listArquivosGrupoFamiliar}
                    onSaveFile={this.props.onSaveFile}
                    onDeleteFile={this.props.removeItemArquivoFamilia}
                />





                <p style={{
                    border: '1px solid rgb(204, 204, 204)',
                    padding: '20px',
                    backgroundColor: 'rgb(255, 254, 209)',
                    textAlign: 'justify'
                }}>
                    Não serão analisadas solicitações sem as devidas documentações anexadas.<br />
                    Confira as documentações necessárias para certificar se nada esta faltando. <br />
                    Você tem até {this.props.perDtFim} para incluir ou alterar os documentos.
                </p>




            </div>
        );

    }
}


// WEBPACK FOOTER //
// ./src/components/grupo-familiar.js